import BaseComponent from '@/components/base';
import { getStyle } from '@/components/media-product-carousel/style';

export default class MediaProductCarousel extends BaseComponent {
  render() {
    return `
    ${this.style}
    <div class="main-wrapper">
      <div class="media-wrapper">
        <media-component
          media-src="${this.mediaSrc}"
          media-src-iphone="${this.mediaSrcIphone}"
          media-src-mobile="${this.mediaSrcMobile}"
          media-type="${this.mediaType}"
          display-media-only
        ></media-component>
        ${
          this.tagImages.length > 0
            ? `<ul class="tag-image-list">
              ${this.tagImages
                .map((tag) => {
                  return `
                  <li>
                    <img class="tag-image" src="${tag}" />
                  </li>`;
                })
                .join('')}
            </ul>`
            : ''
        }
      </div>
      <div class="slider-wrapper">
        <slider-carousel
          hide-thumbnails
          per-page="2"
          gap="20"
          arrows-position="-17px"
          arrows-position-mobile="5px"
        >
          ${this.products
            .map(
              (product) => `
            <div class="image-slide">
              <a class="slide-wrapper" href="${product.url}" target="_blank">
                <div class="slide-image">
                  <img src="${product.image}">
                </div>
                <div class="slide-description">
                  <h3>${product.title}</h3>
                  <p>${product.price}</p>
                </div>
              </a>
            </div>
          `
            )
            .join('')}
        </slider-carousel>
      </div>
    </div>
  `;
  }

  get mediaSrc() {
    return this.getAttribute('media-src');
  }

  get mediaSrcIphone() {
    return this.getAttribute('media-src-iphone');
  }

  get mediaSrcMobile() {
    return this.getAttribute('media-src-mobile');
  }

  get mediaType() {
    return this.getAttribute('media-type');
  }

  get tagImages() {
    return JSON.parse(this.getAttribute('tag-images'));
  }

  get tagAlignment() {
    return this.getAttribute('tag-alignment');
  }

  get products() {
    return JSON.parse(this.getAttribute('products'));
  }

  get style() {
    return getStyle(this.tagAlignment);
  }
}
